export function formatInTimezone(
  value: string | Date | number,
  timezone: string,
  options?: Intl.DateTimeFormatOptions,
): string {
  const raw = typeof value === 'string' && !value.endsWith('Z') && !value.includes('+')
    ? value + 'Z'
    : value;
  const date = raw instanceof Date ? raw : new Date(raw);
  if (isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...options,
  }).format(date);
}

export function getClientTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
